const AddRecptType = Object.freeze({
  Member: 1,
  Team: 2,
  NonNatca: 3,
  All: 4,
  DefaultMember: 5,
});
export default AddRecptType;
